import { createApp } from "vue";
import { createPinia } from "pinia";

import Navigation from "~/vue/Navigation.vue";

// Main app
const navigation = async () => {
	// const pinia = createPinia()
	const app = createApp(Navigation);

	// app.use(pinia)

	return app.mount("#mobile-navigation");
};

// Execute async function
navigation().then(() => {
	window.addEventListener("load", () => {
		document.querySelectorAll(".js-dropdown-navigation").forEach((dropdown) => {
			dropdown.classList.remove("hidden");
		});
	});
});
